module.exports = __webpack_public_path__ + "static/media/folder-hover.16bbf12d.svg";